import { DomainEvent } from "../model/domain-event.model";

export class ServiceLocationAddedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor() {}
}

export class ServiceLocationChangedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor() {}
}

export class ServiceLocationRemovedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor() {}
}
